import React, {Fragment} from 'react';
import { Form, Field } from 'react-final-form';
import {Radio} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';

export default function newSearch(props){
  function onSubmit(params){
    axios.post('/api/list', params);
  }
  return(
    <Form
    onSubmit={onSubmit}
    >
      {props => (
        <form onSubmit={props.handleSubmit}>
        <div style={{width:'100vw', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'80px'}}><Radio title='List type' name='type' select_data={[{value:"0", name:'Company'}, {value:"1", name:'Contact'}]}/></div>
        <div style={{marginTop:'20px', display:'flex', justifyContent:'center', alignItems:'center'}}>
            <div style={{marginLeft:'20px'}}><Field name='name'>{(f)=><TextField label='Name' value={f.input.value} onChange={f.input.onChange}/>}</Field></div>
            <div style={{marginLeft:'20px'}}><Field name='description'>{(f)=><TextField label='Description' value={f.input.value} onChange={f.input.onChange}/>}</Field></div>
        </div>
        <div style={{marginTop:'60px', display:'flex', justifyContent:'center', alignItems:'center'}}><Button type='submit'>Submit</Button></div>
        </form>
      )}
    </Form>
  )
}
